import React, { Component } from 'react';
import { Link } from 'react-router';
import moment from 'moment-timezone';
import { translate } from 'react-i18next';
import { observer } from 'mobx-react';

@observer
export class FlightTable extends Component {
  render() {
    const { flights, t } = this.props;

    return (
      <table className='table'>
        <thead>
        <tr>
          <th className='text-center'>{t('Date')}</th>
          <th className='text-center'>{t('Route')}</th>
          <th className='text-center'>{t('Price per seat')}</th>
          <th className='text-center'>{t('Booked/Required')}</th>
          <th className='text-center'>{t('Status')}</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        {flights.map((flight, index) => {
          const flightOffer = flight.aircraft_offer.flight_offer;
          const startPoint = flightOffer.location.name;
          const dropOffPoint = flightOffer.dropoff_location.name  ||  flightOffer.location.name;
          return (
            <tr key={index}>
              <td>
                <div className='date-time'>
                  <div>{moment(flight.start_time).format('l')}</div>
                  <div>{moment(flight.start_time).format('LT')}</div>
                </div>
              </td>
              <td>
                <div className='route'>
                  <div>{startPoint}</div>
                  <div>&darr;</div>
                  <div>{dropOffPoint}</div>
                </div>
              </td>
              <td className='text-center'>
                {t('{{price}} {{currency}}', {
                  price: parseFloat(flight.aircraft_offer.price_passenger),
                  currency: flight.aircraft_offer.currency_code,
                })}
              </td>
              <td className='text-center'>{flight.booked_seats}/{flight.aircraft_offer.passengers_min}</td>
              <td>
                {flight.confirmed ? <span className='badge badge-pill badge-success'>{t('Confirmed')}</span> : ''}
              </td>
              <td className='book-button text-right'>
                <Link to={`/flight/${flight.id}`}>
                <button className='btn btn-secondary'>{t('Jetzt Buchen')}</button>
                </Link>
              </td>
            </tr>
          );
        })}
        </tbody>
      </table>
    );
  }
}

export default translate()(FlightTable);



// WEBPACK FOOTER //
// ./src/App/Dashboard/Flight/FlightTable.js